import React, { useEffect, useState } from 'react'
import TestimonalsTable from './../components/table/Testimonals'
import './style.css'
import addBtn from './../images/add-button.png'
import closeBtn from './../images/close-button.png'
import { addTestimonial, getAllTestimonials, editTestimonial } from '../../../api'
import { Navigate } from 'react-router-dom';
import axios from 'axios'

function Testimonals(){
  const [isAuth, setIsAuth] = useState(false)
  const [isLoading, setIsLoading] = useState(true)
  const [file, setFile] = useState(null)
  const [edit, setEdit] = useState(false)
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')

  useEffect(() => {
    const isAuthenticated = () => {
      axios.get('https://job-portal-back123.herokuapp.com/auth/admin/verify', {
        credentials: "include",
        withCredentials: true,
        headers: {
          Authorization: localStorage.getItem("token")
        }
      }).then(res => {
        setIsAuth(res.data.success)
        setIsLoading(false)
      }).catch(err => {
        console.log(err)
        window.location = "/admin/signin"
      })
    }
    isAuthenticated()
  }, [])
  const [ formData, setFormData ] = useState({
    name: "",
    location: "",
    description: "",
    avatar: "",
    cloudinary_id: "",
  })

  const [isPoped, setIsPoped] = useState(false)

  const handleChange = (event)=>{
    const { name, value, type, files } = event.target
    setFormData(prevFormData => {
        return {
            ...prevFormData,
            [name]: value
        }
    })
  }

  const openForm = ({ testimonialData })=>{
    console.log("Form opened")
    if (testimonialData) {
      formData.name= testimonialData.name;
      formData._id= testimonialData._id;
      formData.location = testimonialData.location;
      formData.description = testimonialData.description;
      formData.avatar = testimonialData.avatar;
      formData.cloudinary_id = testimonialData.cloudinary_id;
      setEdit(true)
    } else {
      formData.name = "";
      formData.location = "";
      formData.description = "";
      formData.avatar = "";
      formData.cloudinary_id = ""
    }
    setIsPoped(true)
  }

  const closeForm = ()=>{
    setIsPoped(false)
    setEdit(false)
  }

  const uploadFile = async (thumbnail) => {
    const formDataFinal = new FormData()
    formDataFinal.append('file', thumbnail)
    formDataFinal.append('upload_preset', 'ml_default')
    formDataFinal.append('api_key', '375547884857951')

    return axios.post('https://api.cloudinary.com/v1_1/instaclone29/image/upload',
      formDataFinal,
      { headers: { 'X-Requested-With': 'XMLHttpRequest' } }
    )
      .then(uploadRes => uploadRes)
      .then(data => data)
      .catch(err => {
        console.log(err)
        return err.message
      })

  }

  const handleSubmit = async (event) => {
    event.preventDefault()
    setIsSubmitting(true)
    let response, data

    try {
      response = await uploadFile(file)
    } catch (error) {
      setErrorMessage("Error uploading the file")
      setIsSubmitting(false)
      return;
    }
    console.log("Cloudinary Response:", response)

    formData.avatar = response.data.url
    formData.cloudinary_id = response.data.asset_id

    try {
      const { data: response } = edit ? await editTestimonial(formData._id, formData) : await addTestimonial(formData)
      data = response
    } catch (error) {
      setErrorMessage("Error sending form, please check the inputs")
      setIsSubmitting(false)
    }
    // console.log("Final Data:", data)

    if (data.success) alert("Testimonials added succesfully")
    if (data.message) {
      setErrorMessage(data.message)
      setIsSubmitting(false)
    }
  }

  return(
    <>
      {isLoading && <div>Loading...</div>}
      {(!isLoading && !isAuth) && <Navigate to="/admin/signin" />}
      {(!isLoading && isAuth) && (
        <main className="admin__component admin__testimonal">
          <button className="btn btn--circle" onClick={openForm}><img src={addBtn} alt="add testimonals" /></button>
          <form onSubmit={handleSubmit} className={`admin__form grid testimonal__form ${isPoped ? "" : "form__hide"}`}>

            <button className="btn btn--circle form__close" onClick={closeForm}><img src={closeBtn} alt="close add testimonals form" /></button>

            <label className="Testimonal__form__element form__element grid-left">
              <p>Name</p>
              <input
                className="Testimonal__form__input form__input"
                value={formData.name}
                type="text"
                placeholder="name"
                onChange={handleChange}
                name="name"
                required
              />
            </label>

            <label className="Testimonal__form__element form__element grid-left">
              <p>Location detail</p>
              <input
                className="Testimonal__form__input form__input"
                value={formData.location}
                type="text"
                placeholder="location"
                onChange={handleChange}
                name="location"
                // required
              />
            </label>

            <label className="Testimonal__form__element form__element">
              <p>Upload candidate image</p>
              <input
                className="Testimonal__form__input form__input"
                placeholder="image"
                type="file"
                accept="image/*"
                onChange={(e) => setFile(e.target.files[0])}
                name="avatar"
                required
              />
            </label>

            <label className="Testimonal__form__element form__element grid-full">
              <p>Testimonal</p>
              <textarea
                className="Testimonal__form__textarea  form__textarea form__textarea--full"
                value={formData.description}
                placeholder="testimonal"
                onChange={handleChange}
                name="description"
                required
              />
            </label>
            <div className="btn--container grid-left">
              <button disabled={isSubmitting ? true : false} className="btn btn--submit">{isSubmitting ? "Saving..." : "Save Testimonals"}</button>
              <button disabled={isSubmitting ? true : false} className="btn btn--delete">Delete</button>
            </div>
            {(errorMessage) && <p className="message__error grid-full">{errorMessage}</p>}
          </form>
          <TestimonalsTable openForm={openForm} />
        </main>
      )}
      </>
  )
}

export default Testimonals
